import { render, staticRenderFns } from "./GruButton.vue?vue&type=template&id=25f21e74&scoped=true"
import script from "./GruButton.vue?vue&type=script&lang=js"
export * from "./GruButton.vue?vue&type=script&lang=js"
import style0 from "./GruButton.vue?vue&type=style&index=0&id=25f21e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f21e74",
  null
  
)

export default component.exports